<template>
  <el-table
    :empty-text="emptyText"
    :data="rows"
    v-loading="loading"
    :element-loading-text="$tableLoading"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255,255,255,0)"
    :header-cell-style="tableHeaderColor"
    :max-height="$tableMaxHeight"
    @selection-change="handleSelectionChange"
    border
  >
    <el-table-column
      type="selection"
      align="center"
      width="55"
    ></el-table-column>
    <el-table-column type="index" fixed="left" label="STT" width="55" align="center" />
<!--    <el-table-column label="Số hóa đơn" width="220" show-overflow-tooltip fixed="left">-->
<!--      <template v-slot:default="scope">-->
<!--        {{ scope.row.invoiceNo || scope.row.transactionUuid || "-" }}-->
<!--      </template>-->
<!--    </el-table-column>-->
    <el-table-column label="Họ tên" min-width="220" fixed="left">
      <template v-slot:default="scope">
        <el-tooltip placement="top">
          <div slot="content">
            <div>Họ tên: {{ scope.row.kidName || scope.row.fullName || "-" }}</div>
            <div>Bố/Mẹ: {{ scope.row.buyerName || "-" }}</div>
          </div>
          <span style="display:block; overflow:hidden; text-overflow:ellipsis; white-space:nowrap; max-width:200px;">
            {{ scope.row.kidName || scope.row.fullName || "-" }}
          </span>
        </el-tooltip>
      </template>
    </el-table-column>
    <el-table-column label="Lớp" prop="className" width="200"  />
    <el-table-column label="Mã học sinh" prop="kidCode" width="130"  />
    <el-table-column label="Mã Onekids" prop="orderKidCode" width="200"  />
    <el-table-column label="Ngày tạo" width="190" align="center">
      <template v-slot:default="scope">
        {{ formatDateTime(scope.row.createdAt || scope.row.issuedAt) }}
      </template>
    </el-table-column>

    <el-table-column label="Phương thức TT" width="150" align="center">
      <template v-slot:default="scope">
        {{ scope.row.paymentMethodName || "-" }}
      </template>
    </el-table-column>

    <el-table-column label="Thanh toán" width="130" align="center">
      <template v-slot:default="scope">
        <span :style="{ color: scope.row.paymentStatus ? '#1e88e5' : '#fb8c00' }">
          {{ scope.row.paymentStatus ? "Đã TT" : "Chưa TT" }}
        </span>
      </template>
    </el-table-column>

    <el-table-column label="Tổng tiền không chịu thuế" prop="totalAmountWithoutTax" align="right" width="170">
      <template v-slot:default="scope">
        {{ formatCurrency(scope.row.totalAmountWithoutTax) }}
      </template>
    </el-table-column>
    <el-table-column label="Tổng tiền chịu thuế" prop="totalTaxAmount" align="right" width="170">
      <template v-slot:default="scope">
        {{ formatCurrency(scope.row.totalTaxAmount) }}
      </template>
    </el-table-column>
    <el-table-column label="Tổng tiền" prop="totalAmountWithTax" align="right" width="170">
      <template v-slot:default="scope">
        {{ formatCurrency(scope.row.totalAmountWithTax) }}
      </template>
    </el-table-column>
    <el-table-column label="Mã số HĐ" prop="invoiceNo" width="200" align="center" />
    <el-table-column label="Trạng thái" width="170" align="center">
      <template v-slot:default="scope">
        <span :style="{ color: statusColor(scope.row.invoiceStatus || scope.row.status), fontWeight: 500 }">
          {{ statusLabel(scope.row.invoiceStatus || scope.row.status) }}
        </span>
      </template>
    </el-table-column>

    <el-table-column label="Trạng thái gửi CQT" width="170" align="center">
      <template v-slot:default="scope">
        <span :style="{ color: statusColorCQT(scope.row.exchangeStatus), fontWeight: 500 }">
          {{ statusLabelCQT(scope.row.exchangeStatus)}}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="Mã CQT" prop="codeOfTax" width="170" align="center">
    </el-table-column>
    <el-table-column label="Tác vụ" fixed="right" align="center" width="110">
      <template v-slot:default="scope">
        <el-tooltip content="Tải về" placement="top">
          <el-button
            type="primary"
            size="mini"
            circle
            icon="el-icon-download"
            :loading="actionLoading[getRowKey(scope.row)]"
            @click.prevent="downloadIssuedInvoice(scope.row)"
          />
        </el-tooltip>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import ElectronicInvoicesService from '@/services/ElectronicInvoicesService';
import NotifyMessage from '@/commonFuncion/NotifyMessage';
export default {
  name: "InvoiceTabIssued",
  data() {
    return {
      actionLoading: {},
    };
  },
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    emptyText: { type: String, default: "Không có dữ liệu" },
  },
  methods: {
    handleSelectionChange(val) {
      this.$emit('selection-change', Array.isArray(val) ? val : []);
    },
    formatCurrency(value) {
      return `${new Intl.NumberFormat("vi-VN").format(Number(value) || 0)} VND`;
    },
    formatDateTime(value) {
      if (!value) return "-";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      const hh = String(date.getHours()).padStart(2, "0");
      const mm = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      const dd = String(date.getDate()).padStart(2, "0");
      const MM = String(date.getMonth() + 1).padStart(2, "0");
      const yyyy = date.getFullYear();
      return `${hh}:${mm}:${ss} - ${dd}/${MM}/${yyyy}`;
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: 500;";
    },
    statusLabel(status) {
      const map = {
        ONEKIDS_DRAFT: "Lưu nháp",
        DRAFT: "Hóa đơn nháp",
        ISSUED: "Đã phát hành",
      };
      return map[status] || status || "-";
    },
    statusLabelCQT(status) {
      const map = {
        0: "Chưa gửi CQT",
        1: "Đã gửi CQT",
        2: "CQT tiếp nhận",
        3: "CQT từ chối",
        4: "Lỗi gửi CQT",
      };
      return map[status] || status || "-";
    },
    statusColor(status) {
      const map = {
        ONEKIDS_DRAFT: "#fb8c00",
        DRAFT: "#78909c",
        ISSUED: "#1e88e5",
      };
      return map[status] || "#303133";
    },

    statusColorCQT(status) {
      // Map màu phù hợp với label:
      // 0: Chưa gửi CQT -> warning (cam)
      // 1: Đã gửi CQT -> info (xanh dương)
      // 2: CQT tiếp nhận -> success (xanh lá)
      // 3: CQT từ chối -> error (đỏ)
      // 4: Lỗi gửi CQT -> error đậm (đỏ sẫm)
      const map = {
        0: "#fb8c00",
        1: "#1e88e5",
        2: "#2e7d32",
        3: "#e53935",
        4: "#b71c1c",
      };
      return Object.prototype.hasOwnProperty.call(map, status) ? map[status] : "#303133";
    },
    async downloadIssuedInvoice(row) {
      const key = this.getRowKey(row);
      this.$set(this.actionLoading, key, true);
      try {
        const request = { transactionUuid: row.transactionUuid, invoiceNo: row.invoiceNo };
        // try preview endpoint to get PDF arraybuffer
        const resp = await ElectronicInvoicesService.downloadInvoice(request);
        const arrayBuffer = resp && resp.data ? resp.data : resp;
        if (!arrayBuffer) {
          NotifyMessage.leftCornerNotificationError('Không có dữ liệu file để tải');
          return;
        }
        const blob = new Blob([arrayBuffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = (row.invoiceNo && String(row.invoiceNo).trim()) ? `${row.invoiceNo}.pdf` : `invoice-${Date.now()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        NotifyMessage.leftCornerNotificationSuccess('Tải xuống thành công');
      } catch (err) {
        console.error('downloadIssuedInvoice error', err);
        NotifyMessage.leftCornerNotificationError('Tải xuống thất bại');
      } finally {
        this.$set(this.actionLoading, key, false);
      }
    },
    getRowKey(row) {
      return row.transactionUuid || row.invoiceNo || row.orderKidCode || String(row.id || row.key || '') || Math.random().toString(36).substr(2, 9);
    },
  },
};
</script>

